export default __webpack_public_path__ + "static/media/rounded-train-3x.095231ef.webp";